import React from 'react'
import { convertStructToRegular } from './components/compile-short'
import store from './store'
export function isStoryValidated(){
  if(store.steps?.length==0) return false
  for(var i in store.steps) {
    if(!isStepValidated(i)) return false
  }
  return true
}
export function getStoryErrors(){
  // if(store.steps?.length==0) {
    // return []
}

export function isStepValidated(stepIndex) {
  var step=store.steps[stepIndex]
  if(!step) return false
  if(step.type=='ETHER_FUND') {
    if (!isFieldValidated(stepIndex,'to')) return false
    if (!isFieldValidated(stepIndex,'gwei')) return false
  }
  if(step.type=='ENCODE_TRANSACTION') {
    // if (!isFieldValidated(stepIndex,'value')) return false
    if (!isFieldValidated(stepIndex,'parameters')) return false
    if (!isFieldValidated(stepIndex,'from')) return false
    if (!isFieldValidated(stepIndex,'to')) return false
    if (!isFieldValidated(stepIndex,'manualBlock')) return false
  }
  if(step.type=='CHECk_BALANCE') {
    if (!isFieldValidated(stepIndex,'to')) return false
  }
  if(step.type=='COMPILE_SMART_CONTRACT') {
    if (!isFieldValidated(stepIndex,'parameters')) return false
    if (!isFieldValidated(stepIndex,'abiLoadingStatus')) return false
    if (!isFieldValidated(stepIndex,'deployedAddress')) return false
    if (!isFieldValidated(stepIndex,'from')) return false
    if (!isFieldValidated(stepIndex,'compilerVerson')) return false
    if (!isFieldValidated(stepIndex,'compilationErrors')) return false
  }
  return true
}

export function isFieldValidated(stepIndex,field,parameterIndex=null) {
  var step=store.steps[stepIndex]
  if(!step) return false
  // if(step.type=='ETHER_FUND') {
    if(field=='to') {
      if(!isAddressValid(step[field])) return false      
    }
    if(field=='manualBlock') {
      if(!step['manualBlock']) return true
      if(!step['blockNumber']) return false
      if(String(!step['blockNumber'] || '').match(/^[0-9]+$/)) return false
      if(!step['blockTimestamp']) return false
    }
    if(field=='from') {
      if(!isAddressValid(step[field])) return false      
    }
    if(field=='alias') {
      if(!step[field]) return false      
    }
    if(field=='compilerVersion') {
      if(!step[field]) return false      
    }
    if(field=='compilationErrors') {
      if(step[field] && step[field].length>0) return false      
    }
    if(field=='abiLoadingStatus') {
      if(step[field] && step[field]!='ready') return false      
    }
    if(field=='from' && step.type=='COMPILE_SMART_CONTRACT' && step.deploy=="yes") {
      if(!isAddressValid(step[field])) return false      
    }
    if(field=="deployedAddress" && (step.deploy=="no" || step.deploy=="abi")) {
      if(!isAddressValid(step[field])) return false      
    }
    if(field=='gwei' || field=='value') {
      if(!step[field]) return false
    }
    if(field=='execute') {
      if(!step[field]) return false
    }
    if(field=='deploy') {
      if(!step[field]) return false
    }
    if(field=='data') {
      if(!step[field]) return true
      if(!step[field].match(/^[0-9a-f]+$/i)) return false
    }
    if(field=="parameters") {
      var functionParams = step?.abi?.find(x => x.signature==step.function_signature)?.inputs
      
      if(step.type=="COMPILE_SMART_CONTRACT") {
        functionParams = step?.abi?.find(x => x.type=="constructor")?.inputs
      }


      var val
      if(parameterIndex !== null) {
        
        var type=functionParams?.[parameterIndex]?.type
        var components=functionParams?.[parameterIndex]?.components

        if(components) {
          return true
        }
        if(!type) return
        val=step.parameters?.[parameterIndex]
        var isArray=!!type.match(/\[/) || Array.isArray(val)
        if(isArray) {
          // simple array uint[]
          var arrayLength=type.match(/\[([0-9]+)\]/)?.[1] 
          if(type.match(/\[/g).length==2) {
            var isNested=true
          }
          type=type.replace(/\[.*\]/g,'')
          // is an array
          if(!val) return
          if(isNested) {
            // nested array uint[][]
            for(var j=0;j<(arrayLength===undefined ? val.length : arrayLength);j++) {
              var _val=val[j]
              for(var i=0;i<(arrayLength===undefined ? _val.length : arrayLength);i++) {
                let isValid=checkPureParameter(type,_val?.[i])
                if(!isValid) return false
              }
            }
          } else {
            for(var i=0;i<(arrayLength===undefined ? val.length : arrayLength);i++) {
              let isValid=checkPureParameter(type,val[i])
              if(!isValid) return false
            }
          }

        } else {
          // is not array
          let isValid=checkPureParameter(type,val)
          if(!isValid) return false              
        }

      } else {
          // In step list (on the left), we need to check all parameters
          for(let i in functionParams) {
            let isValid=isFieldValidated(stepIndex,'parameters',i)
            if(!isValid) return false
          }
      }
    }    
  // }
  return true
}

function getStepByAliasName(aliasName) {
 return store.steps.find(
    s =>
      s.type == 'COMPILE_SMART_CONTRACT' &&
      s.alias == aliasName,
  )
}
export function isAddressValid(addressField){
  if(!addressField) return false
  if(addressField?.type=="choose" && !addressField.chosenValue) return false
  if(typeof addressField=='string' && !addressField.match(/^0x[a-fA-F0-9]{40}/)) return false
  return true
}
function getFunctionListByAliasName(aliasName) {
 var step=getStepByAliasName(aliasName)
 return step?.abi?.filter(abiField => abiField.type == "function") || []
}

function checkPureParameter(type,val) {
  if(type.match(/uint/) && !type.match(/[]/)) {
    if(!val) return false
    if(!val.match(/^[0-9]+$/)) return false
  }
  if(type=="address") {
    if(!val) return false
    if(!isAddressValid(val)) return false
  }
  return true
}
export const invalidColor='rgb(249 120 120 / 60%)'